import { Component, Input } from '@angular/core';
import { GrundstueckId } from '../../../core/av-api';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';
import { HaengigeGeschaefteAuftraegeIcpComponent } from '../haengige-geschaefte-auftraege-icp/haengige-geschaefte-auftraege-icp.component';

@Component({
  selector: 'cap-grundstueck-haengige-icp',
  imports: [HaengigeGeschaefteAuftraegeIcpComponent],
  templateUrl: './grundstueck-haengige-icp.component.html'
})
export class GrundstueckHaengigeIcpComponent {
  @Input()
  hasRight: boolean = true;

  grundstueckIds: Array<GrundstueckId>;

  constructor() {
    keysToTranslate<string>(['HAENGIGE']);
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this.grundstueckIds = new Array<GrundstueckId>();
    this.grundstueckIds.push(value);
  }
}
